import { defineStore, StoreDefinition } from "pinia"
import { upperFirst } from "lodash-es"
import { setStorage, getStorage, removeStorage } from "@/utils"
import { Login } from "@/types"

type AppStore = ReturnType<
	StoreDefinition<string, AppStoreState, AppStoreGetters, AppStoreActions>
>

export interface AppStoreState {
	userinfo: Login.SuccessResponseData | null
}

export interface AppStoreGetters {
	isLogin: (this: AppStoreGetters, state: AppStoreState) => boolean
	userHeader: (this: AppStore, state: AppStoreState) => string
	[key: string]: any
}

export interface AppStoreActions {
	setUserInfo: (userinfo: Login.SuccessResponseData | null) => void
}

const STORE_USERINFO_KEY = `STORAGE_USER_INFO`

export const useAppStore = defineStore<
	string,
	AppStoreState,
	AppStoreGetters,
	AppStoreActions
>("app", {
	state: () => {
		const userinfo = getStorage<Login.SuccessResponseData>(STORE_USERINFO_KEY)
		return {
			userinfo
		}
	},
	actions: {
		setUserInfo(userinfo: Login.SuccessResponseData | null): void {
			this.userinfo = userinfo
			if (userinfo) {
				setStorage(STORE_USERINFO_KEY, userinfo)
			} else {
				removeStorage(STORE_USERINFO_KEY)
			}
		}
	},
	getters: {
		isLogin: (state): boolean =>
			!!(state.userinfo && state.userinfo.access_token),
		userHeader(this: AppStore, state): string {
			if (!this.isLogin) return ""
			return `${upperFirst(state.userinfo!.token_type)} ${
				state.userinfo!.access_token
			}`
		}
	}
})
